import { useQuery } from '@tanstack/react-query';
import { WishlistApiClient } from 'api';

export const useWishlist = (id: string) => {
  return useQuery({
    queryKey: ['wishlists', id],
    queryFn: () => WishlistApiClient.getWishlistById(id),
    enabled: !!id,
  });
};

export const useWishlistArtists = (id: string) => {
  return useQuery({
    queryKey: ['wishlists', id, 'artists'],
    queryFn: () => WishlistApiClient.getWishlistArtists(id),
    enabled: !!id,
  });
};

export const useWishlistMarket = (id: string) => {
  return useQuery({
    queryKey: ['wishlists', id, 'market'],
    queryFn: () => WishlistApiClient.getWishlistMarket(id),
    enabled: !!id,
  });
};

export const useWishlistListings = (id: string, page = 1) => {
  return useQuery({
    queryKey: ['wishlists', id, 'listings', { page }],
    queryFn: () => WishlistApiClient.getWishlistListings(id, page),
    enabled: !!id,
  });
}; 